export const ROUTE_META_DATA = {
  pools: {
    metaTitle: 'Pools | Regenerative',
    metaDescription:
      'Engage with the heart of DeFi by managing and providing liquidity on Regenerative Finance, a cornerstone for building a more resilient and inclusive financial future',
  },
  pool: {
    metaTitle: 'Pools | Regenerative',
    metaDescription: '[pool_name] — a Regenerative [pool_type] pool ',
  },
  swap: {
    metaTitle: 'Token Swap on Celo | Regenerative ',
    metaDescription:
      'Effortlessly swap DeFi tokens on the Celo blockchain with Regenerative Finance. Secure, fast, and user-friendly token exchange for a seamless trading experience',
  },
  dashboard: {
    metaTitle: 'Your Dashboard | Regenerative',
    metaDescription:
      'Access your personal Regenerative Finance dashboard to earn rewards, claim ReFi points, level up, and manage your NFTs all in one convenient place',
  },
  claim: {
    metaTitle: 'Claim liquidity mining incentives from staking',
    metaDescription:
      'LPs who stake can claim liquidity mining incentives. veBAL holders can boost incentives and claim their share of protocol revenue',
  },
  portfolio: {
    metaTitle: 'Regenerative portfolio',
    metaDescription:
      'Track your Regenerative Portfolio, including your unstaked and stake LP positions',
  },
  vebal: {
    metaTitle: 'veBAL tokenomics',
    metaDescription:
      'Get veBAL (voter escrowed B-80BAL-20WETH) for extra liquidity mining incentives, governance voting power and a share of protocol revenue',
  },
  'terms-of-use': {
    metaTitle: 'Regenerative Terms of Use',
    metaDescription: 'The rules for the use of the website',
  },
  'privacy-policy': {
    metaTitle: 'Regenerative Privacy Policy',
    metaDescription:
      'How this website collects, uses and shares personal information',
  },
  'cookies-policy': {
    metaTitle: 'Regenerative Cookie Policy',
    metaDescription: 'How this website uses browser cookies',
  },
  risks: {
    metaTitle: 'Regenerative Protocol Risks',
    metaDescription: 'The risks of using the Regenerative Protocol',
  },
};
